import { useMutation, useQuery } from '@tanstack/react-query';

import { SignatureImageUploadParams, SignatureUpdateParams } from '../../interfaces/Signature';
import SignatureService from '../../services/SignatureService';

export enum SIGNATURE_QUERY_KEYS {
  GET_SIGNATURE = 'get-signature',
  UPDATE_SIGNATURE = 'update-signature',
  UPLOAD_SIGNATURE_IMAGE = 'upload-signature-image',
}

const signatureService = new SignatureService();

export const getSignatureQueryConfig = (hashId: string) => ({
  queryKey: [SIGNATURE_QUERY_KEYS.GET_SIGNATURE, hashId],
  queryFn: () => signatureService.getSignature(hashId!),
});

export const useGetSignatureQuery = (hashId: string) => {
  const { data: signature, isLoading, isError } = useQuery(getSignatureQueryConfig(hashId));

  return {
    signature,
    isLoading,
    isError,
  };
};

export const useUpdateSignatureMutation = () => {
  const { mutateAsync, isPending } = useMutation<void, Error, SignatureUpdateParams>({
    mutationKey: [SIGNATURE_QUERY_KEYS.UPDATE_SIGNATURE],
    mutationFn: (params) => signatureService.updateSignature(params),
  });

  return {
    updateSignature: mutateAsync,
    isUpdating: isPending,
  };
};

export const useUploadSignatureImageMutation = () => {
  const { mutateAsync, isPending } = useMutation<void, Error, SignatureImageUploadParams>({
    mutationKey: [SIGNATURE_QUERY_KEYS.UPLOAD_SIGNATURE_IMAGE],
    mutationFn: (params) => signatureService.uploadImage(params),
  });

  return {
    uploadSignatureImage: mutateAsync,
    isUploading: isPending,
  };
};
